module.exports = __webpack_public_path__ + "assets/3e1afad5401110f8ef73110e27664f6f.png";